<template>
  <div class="table table-bg">
    <div class="table-header center">
      <div class="table-tlt center-left">
        <h2>부서 상세 정보 조회</h2>
      </div>
      <div class="table-btn center-right">
        <div>
          <button class="btn btn-140" @click="goList">부서 리스트</button>
        </div>
        <div>
          <button class="btn btn-140" @click="deleteDivision">
            <span v-if="!processing" class="process">부서 삭제</span>
            <ButtonLoading v-else></ButtonLoading>
          </button>
        </div>
        <div>
          <button class="btn btn-140" @click="updateDivision">부서 수정</button>
        </div>
      </div>
    </div>
    <div class="table-desc">
      <div v-if="detailType === 'view'" class="table-content">
        <table>
          <tr>
            <td class="header">부서 ID</td>
            <!-- TODO <td>{{ division.divisionAlias }}</td> -->
            <td>{{ division.divisionID }}</td>
          </tr>
          <tr>
            <td class="header">회사 ID</td>
            <!-- TODO <td>{{ division.companyAlias }}</td> -->
            <td>{{ division.companyID }}</td>
          </tr>
          <tr>
            <td class="header">회사 역할</td>
            <td>{{ $getConstName('companyScope', division.scope) }}</td>
          </tr>
        </table>
        <div class="vertical-line"></div>
        <table>
          <tr>
            <td class="header">부서 이름</td>
            <td>{{ division.divisionName }}</td>
          </tr>
          <tr>
            <td class="header">회사 이름</td>
            <td>{{ division.companyName }}</td>
          </tr>
          <tr>
            <td class="header"></td>
            <td></td>
          </tr>
        </table>
      </div>
      <div v-if="detailType === 'edit'" class="table-content">
        <table>
          <tr>
            <td class="header">부서 ID</td>
            <!-- TODO <td><input type="text" v-model="editDivision.divisionAlias" /></td> -->
            <td> {{ editDivision.divisionID }} </td>
          </tr>
          <tr>
            <td class="header">회사 ID</td>
            <!-- TODO <td>{{ division.companyAlias }}</td> -->
            <td>{{ division.companyID }}</td>
          </tr>
          <tr>
            <td class="header">회사 역할</td>
            <td>{{ $getConstName('companyScope', division.scope) }}</td>
          </tr>
        </table>
        <div class="vertical-line"></div>
        <table>
          <tr>
            <td class="header">부서 이름</td>
            <td><input type="text" v-model="editDivision.divisionName" /></td>
          </tr>
          <tr>
            <td class="header">회사 이름</td>
            <td>{{ division.companyName }}</td>
          </tr>
          <tr>
            <td class="header"></td>
            <td></td>
          </tr>
        </table>
      </div>
      <div v-if="detailType === 'edit'" class="table-btn center">
        <button
          class="btn btn-140 btn-blue-line" @click="excuteUpdate">
          <span v-if="!processing" class="process">수정</span>
          <ButtonLoading v-else></ButtonLoading>
        </button>
        <button
          class="btn btn-right"
          @click="cancelUpdate"
        >취소</button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */

import Configuration from '@/js/Configuration';
import ButtonLoading from '@/components/include/ButtonLoading';

export default {
  props: [
    'division',
  ],
  components: {
    ButtonLoading,
  },
  data: () => ({
    detailType: 'view',
    editDivision: null,
    processing: false,
  }),
  methods: {
    updateDivision() {
      this.editDivision = JSON.parse(JSON.stringify(this.division));
      this.detailType = 'edit';
    },
    async excuteUpdate() {
      try {
        this.processing = true;
        const url = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/division/${this.division.divisionID}`;

        const param = this.editDivision;
        const createResult = await this.$http.put(url,
          param,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          });
        if (createResult.status !== 200) {
          throw new Error(`Response status is "${createResult.status}"`);
        }
        if (createResult.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${createResult.data.resultCode}"`);
        }

        const company = {
          id: this.division.companyID,
          name: this.division.companyName,
          alias: this.division.companyAlias,
          registrationNo: this.division.registrationNo,
          scope: this.division.scope,
        };

        this.processing = false;
        this.$emit('refreshList', company, 'company', 1);
      } catch (e) {
        this.processing = false;
        console.error(e);
      }
    },
    cancelUpdate() {
      this.detailType = 'view';
    },
    async deleteDivision() {
      this.processing = true;
      const division = await this.$getDivision(this.division.divisionID, true, true);
      if (!division) {
        alert('존재하지 않는 부서입니다.');
        this.processing = false;
        return;
      } else if (division.users && division.users.length > 0) {
        alert('사용자가 있는 부서는 삭제할 수 없습니다.\n"계정 관리"를 확인해 주세요.');
        this.processing = false;
        return;
      } else if (division.devices && division.devices.length > 0) {
        let d = '';
        if (division.devices) {
          for (let i = 0; i < division.devices.length; i++) {
            if (i !== 0) {
              d += ', ';
            }
            d += division.devices[i].deviceName;
          }
        }
        alert(`냉장고를 관리하는 부서는 삭제할 수 없습니다.\n"냉장고 관리"를 확인해 주세요.\n냉장고: ${d}`);
        this.processing = false;
        return;
      }

      if (!confirm('정말 삭제하시겠습니까?')) {
        this.processing = false;
        return;
      }

      try {
        const url = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/division/${this.division.divisionID}`;

        const createResult = await this.$http.delete(url,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          });
        if (createResult.status !== 200) {
          throw new Error(`Response status is "${createResult.status}"`);
        }
        if (createResult.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${createResult.data.resultCode}"`);
        }

        const company = {
          id: this.division.companyID,
          name: this.division.companyName,
          alias: this.division.companyAlias,
          registrationNo: this.division.registrationNo,
          scope: this.division.scope,
        };

        this.processing = false;
        this.$emit('refreshList', company, 'company', 1);
      } catch (e) {
        if (e.response.status === 403) {
          alert('사용중 입니다.');
        } else {
          console.error(e);
        }
        this.processing = false;
      }
    },
    goList() {
      const company = {
        id: this.division.companyID,
        name: this.division.companyName,
        alias: this.division.companyAlias,
        registrationNo: this.division.registrationNo,
        scope: this.division.scope,
      };

      this.$emit('refreshList', company, 'company');
    },
  },
};
</script>

<style scoped>
.division-detail {
  margin-top: 28px;
}
.division-detail .buttons {
  display:flex;
  float: right;
}
.division-detail .buttons.edit-botton {
  float: unset;
  justify-content: center;
  margin-top: 10px;
}
.division-detail .buttons .btn {
  width: 100px;
  height: 30px;
  font-size: 12px;
  font-weight: bold;
  border-radius: 4px;
  cursor: pointer;
  transition: 0.2s;
  margin-bottom: 10px;
  margin-left: 10px;
  color: #ffffff;
  background-color: green;
}
.division-detail .buttons .btn:disabled {
  background-color: #dedede !important;
  color: #ffffff !important;
  border: solid 1px #dedede !important;
  cursor: default;
}
.division-detail .buttons .btn.hover {
  background-color: rgb(1, 148, 1);
}
.division-detail table {
  margin-top: 48px;
  width: 100%;
  text-align: center;
  border-collapse: collapse;
}
.division-detail table tr {
  height: 75px;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.17px;
  color: #586063;
  border-bottom: solid 1px #dee0e3;
}
.division-detail table tr.header {
  background-color: #ffffff;
  color: #b0bec5;
}
.division-detail table th {
  border-right: solid 1px #dee0e3;
}
.division-detail table td .time {
  font-weight: normal;
}
input, select {
  width: 90%;
  height: 46px;
  border: solid 1px #d7dadb;
  background-color: #ffffff;
  padding: 13px 12px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/account/division/DivisionDetail.vue